import * as helpers from '../helpers';

export default function initLocaliserPopup() {
    const links = [...document.querySelectorAll('.localiser-popup-link')];

    links.forEach((link) => {
        if (helpers.hasClass(link, '-is-initialized')) {
            return;
        }

        helpers.addClass(link, '-is-initialized');

        $(link).fancybox({
            touch: false,
            type: 'iframe',
            afterLoad(_, current) {
                const currentSlide = current.$slide[0];
                const iframe = currentSlide.querySelector('iframe');
                const iframeDocument = iframe.contentWindow.document;
                const mapElement = iframeDocument.querySelector('[data-map]');
                const iframeBody = iframeDocument.querySelector('body');
                const iframeHTML = iframeDocument.querySelector('html');
                const updateMapButton = iframeDocument.querySelector('.update-mobile-map');

                iframeBody.style.height = '100%';
                iframeHTML.style.height = '100%';


                let mapInstance;

                helpers.addClass(currentSlide, 'js-localiser-popup');
                if (iframe.contentWindow.maps) {
                    mapInstance = iframe.contentWindow.maps.filter(map => map.id === mapElement.getAttribute('data-storage-id'))[0];
                }

                if (updateMapButton) {
                    updateMapButton.click();
                }

                if (mapInstance) {
                    mapInstance.updateBounds([50, 30, 30, 50]);
                    mapInstance.updateSize();
                }
            },
        });
    });
}
